import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { LogOut, Copy, ChevronDown, User } from 'lucide-react';
import styles from './AffiliateHeader.module.css';
import { logoutUser } from 'slices/auth/login/thunk';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AffiliateHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const profile = useSelector((state: any) => state.Affiliate.profile);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const firstName = profile?.first_name ?? '';
  const lastName = profile?.last_name ?? '';
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'A';
  const fullName = profile?.name ?? (`${firstName} ${lastName}`.trim() || 'Affiliate');
  const affiliateCode = profile?.affiliate_code ?? '—';

  const handleCopyCode = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(affiliateCode);
      } else {
        const el = document.createElement('textarea');
        el.value = affiliateCode;
        el.style.position = 'fixed';
        el.style.opacity = '0';
        document.body.appendChild(el);
        el.focus();
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
      toast.success('Affiliate code copied!');
    } catch {
      toast.error('Failed to copy code.');
    }
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/affiliate_login');
  };

  return (
    <>
    <header id="page-topbar" className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.right}>
          <button className={styles.codeBadge} onClick={handleCopyCode} title="Copy affiliate code">
            <span className={styles.codeLabel}>Code</span>
            <span>{affiliateCode}</span>
            <Copy size={12} />
          </button>

          <div className={styles.profileWrapper} ref={dropdownRef}>
            <button className={styles.profileBtn} onClick={() => setDropdownOpen(o => !o)}>
              <div className={styles.avatar}>{initials}</div>
              <span className={styles.userName}>{fullName}</span>
              <ChevronDown size={14} className={styles.chevron} />
            </button>
            {dropdownOpen && (
              <div className={styles.dropdown}>
                <Link
                  to="/affiliate/profile"
                  className={styles.dropdownItem}
                  onClick={() => setDropdownOpen(false)}
                >
                  <User size={14} />
                  View Profile
                </Link>
                <button className={styles.dropdownItem} onClick={handleLogout}>
                  <LogOut size={14} />
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
    <ToastContainer position="top-right" autoClose={2500} />
    </>
  );
};

export default AffiliateHeader;
